import styled from 'styled-components';

export const ListBannerContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  border-radius: 3px;
  box-shadow: var(--ds-shadow-overlay, var(--ds-fb-shadow-overlay));
  padding: 24px;
`;

export const ListBannerContentContainer = styled.div`
  display: flex;
`;

export const ListBannerTextContainer = styled.div`
  flex: 1 1 auto;
`;

export const ListBannerTitle = styled.h4`
  margin-bottom: 18px;
`;

export const ListBannerList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 26px 0;
`;

export const ListBannerListItem = styled.li`
  padding: 0;
  margin: 0;
  display: flex;
  align-content: center;
  justify-content: start;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const ListBannerImage = styled.img`
  max-width: 140px;
  height: auto;
`;

export const ListBannerListItemTitle = styled.span`
  margin-left: 4px;
  overflow-wrap: break-word;
  color: var(--ds-text-accent-gray, var(--ds-fb-text-accent-gray));
`;

export const ListBannerButtonContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: start;
  align-items: center;
  gap: 22px;
`;
